export const NOTIFICATIONS_COUNT_REFRESH_INTERVAL = 300000; // 5 minutes
